export var REPO_NAME = 'homemade-gpt-js';
export var REPO_URL = "https://github.com/trekhleb/".concat(REPO_NAME);
export var BASE_PATH = "/".concat(REPO_NAME);
export var GPT_MODEL_FILE_PATH = "".concat(REPO_URL, "/blob/main/gpt/src/model.ts");
export var X_URL = 'https://x.com/trekhleb';
export var TREKHLEB_DEV_URL = 'https://trekhleb.dev';
export var MODEL_WEIGHTS_BASE_URL = 'https://trekhleb.dev/homemade-gpt-js-weights/';
export var KARPATHY_MIN_GPT_REPO_PATH = 'https://github.com/karpathy/minGPT';
export var RECIPE_BOX_DATASET_URL = 'https://eightportions.com/datasets/Recipes/';
